import { useEffect, useState } from "react"

export function useResizeDetector(debounceMs = 150) {
  const [isResizing, setIsResizing] = useState(false)

  useEffect(() => {
    if (typeof window === "undefined") return

    let resizeTimeout: NodeJS.Timeout

    function handleResize() {
      setIsResizing(true)
      clearTimeout(resizeTimeout)
      resizeTimeout = setTimeout(() => {
        setIsResizing(false)
      }, debounceMs)
    }

    window.addEventListener("resize", handleResize)
    return () => {
      window.removeEventListener("resize", handleResize)
      clearTimeout(resizeTimeout)
    }
  }, [debounceMs])

  return isResizing
}
